import React from 'react';
import './FacelessVideoFactory.css';

const ControlsPanel = ({ isAutoPilot, setIsAutoPilot }) => {
  return (
    <div className="fvf-glass-card" style={{ padding: '16px 24px', display: 'flex', alignItems: 'center', gap: '24px' }}>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <span style={{ color: 'white', fontWeight: 'bold', fontSize: '1rem' }}>Full Auto-Pilot</span>
        <span style={{ color: '#8b949e', fontSize: '0.75rem' }}>Bypass manual review</span>
      </div>

      {/* Toggle Switch */}
      <div 
        onClick={() => setIsAutoPilot(!isAutoPilot)}
        style={{
          width: '52px',
          height: '28px',
          background: isAutoPilot ? 'linear-gradient(135deg, #7928ca, #ff007f)' : '#30363d',
          borderRadius: '14px',
          position: 'relative',
          cursor: 'pointer',
          transition: 'all 0.3s ease',
          boxShadow: isAutoPilot ? '0 0 10px rgba(255, 0, 127, 0.4)' : 'none'
        }}
      >
        <div style={{
          width: '20px',
          height: '20px',
          background: 'white',
          borderRadius: '50%',
          position: 'absolute',
          top: '4px',
          left: isAutoPilot ? '28px' : '4px',
          transition: 'all 0.3s cubic-bezier(0.4, 0.0, 0.2, 1)',
          boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
        }} />
      </div>
    </div>
  );
};

export default ControlsPanel;
